import { Map, OrderedSet } from 'immutable';

import * as types from '../test-overview/types';

const initialState = new Map({
  errorCountByDate: new OrderedSet(),
  aggregatedErrors: new OrderedSet(),
});

const testErrorReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.GET_TEST_TRENDS.SUCCESS:
      return state.withMutations((newState) => {
        const errors = payload.buckets.map((bucket) => {
          const errored = bucket.aggs.status.find((status) => (
            status.name === 'errored'
          ));
          return { name: bucket.datetime, errorCount: errored ? errored.count : 0 };
        });
        newState.set('errorCountByDate', new OrderedSet(errors));
      });
    case types.GET_AGGREGATED_TEST_ERRORS.SUCCESS:
      return state.withMutations((newState) => {
        // sort the output first
        payload.buckets.sort((itemLeft, itemRight) => itemLeft.count < itemRight.count);
        const errors = new OrderedSet(
          payload.buckets.map((item) => ({
            name: item.name,
            count: item.count,
            items: item.items,
          })),
        );
        newState.set('aggregatedErrors', errors);
      });
    default:
      return state;
  }
};

export default testErrorReducer;
export { initialState };
